import './DailyWheelButton.scss';
import { observer } from "mobx-react";
import { useEffect } from "react";
import promoIcon from '../../../../../assets/icons/wheel.svg';
import { fortuneWheelStore, promoStore } from "../../../../../platform/stores";

export const DailyWheelButton = observer(() => {
  const { dailyWheelButtonIsVisible, shouldBounce } = fortuneWheelStore;

  // Stop bounce when modal opens
  useEffect(() => {
    if (fortuneWheelStore.dailyWheelModalIsOpen && shouldBounce) {
      fortuneWheelStore.setShouldBounce(false);
    }
  }, [fortuneWheelStore.dailyWheelModalIsOpen]);

  const handleClick = () => {
    // Stop bounce when button is clicked
    if (shouldBounce) {
      fortuneWheelStore.setShouldBounce(false);
    }
    fortuneWheelStore.setDailyWheelModalIsOpen(true);
  };

  return (
    <>
      {dailyWheelButtonIsVisible && (
        <div
          className={`daily-wheel-button ${promoStore.promoButtonIsVisible ? 'second-btn' : ''} ${shouldBounce ? 'bounce' : ''}`}
          onClick={handleClick}>
          <img src={promoIcon} alt="DailyWheel"/>
        </div>
      )}
    </>
  );
})
